module.exports = __webpack_public_path__ + "static/media/icon-dashboard.a3e37102.svg";